module.exports = __webpack_public_path__ + "res/glyphicons-halflings-regular.eot?f4769f9bdb7466be65088239c12046d1";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 5
// module chunks = 0